import { defineStore } from "pinia";
import { ref } from "vue";

/**
 * environment store
 * Retrieve the environment config from non-bundled file
 * The "env.json" file is added to the /public folder so it will just be copied to the dist folder on build
 * Before deploying to azure, the file could be replaced by a custom one written for the specific azure environment.
 * eg: api_url should be "" in the case of an api linked to the swa or the api url otherwise.
 */
export const useEnv = defineStore("env", () => {

    const api_url = ref("");
    /**
     * fetch environment config during store initialization
     */
    async function initialize() {
        const env = await fetch('/env.json');
        const x = await env.json();
        api_url.value = x.api_url;
    }

    return { api_url, initialize };
});
